import React from "react";
import { Button } from "react-bootstrap";
const SubmitButton = ({ children }) => (
  <div>
    <Button id="btn outline" type="submit">
      {children}
    </Button>
  </div>
);

export default SubmitButton;
